import BaseError from './BaseError';

class SdkNotLoadedError extends BaseError {
  constructor() {
    super('SDK has not been loaded yet.');
  }
}

export default SdkNotLoadedError;
